import { WILKS } from "../constants";

function getWilks(gender, weight, total) {
  const options = WILKS[gender];
  if (!options) return 0;
  const wilks = options.wilks;
  const maxWeight = options.maxWeight;
  const minWeight = options.minWeight;
  const lowFactor = options.lowFactor;
  const highFactor = options.highFactor;
  const roundedMaxWeight = Math.round(maxWeight);
  const roundedMinWeight = Math.round(minWeight);
  let factor = null;

  // Weight too high - use high factor.
  if (weight >= maxWeight) factor = highFactor;
  // Weight too low - use low factor.
  else if (weight <= minWeight) factor = lowFactor;
  // Do wilks table lookup.
  else {
    for (var i = roundedMinWeight; i < roundedMaxWeight; i++) {
      if (weight >= i && weight < i + 1) {
        factor =
          wilks[(i - roundedMinWeight) * 10 + Math.round((weight - i) * 10)];
        break;
      }
    }
  }

  return total * factor;
}

export default getWilks;
